<template>
  <div class="car_rent_detail">
    <div class="car_detail">
      <div class="detail_box">
        <img
          class="back"
          src="../../assets/carRent/reback@2x.png"
          @click="goBack"
        />
        <van-row>
          <van-col span="24" class="banner">
            <van-swipe
              class="car_rent_swipe"
              @change="onChange"
              v-if="swiper.length > 0"
            >
              <van-swipe-item v-for="(item, index) in swiper" :key="index">
                <img class="item" :src="item" @error="defaultPro()" />
              </van-swipe-item>
              <div class="custom-indicator" slot="indicator">
                <span class="indexes">{{ label + 1 }}/{{ swiper.length }}</span>
              </div>
            </van-swipe>
          </van-col>
        </van-row>

        <div class="car_dec">
          <van-row class="car_detail_dec">
            <van-col span="24">
              <p class="name">{{ detailInfo.name }}</p>
              <p class="price">
                ￥<span class="unit">{{ detailInfo.daily_rent }}</span
                ><span class="dec">/日租价</span
                ><span class="full_price"
                  >指导价￥{{ detailInfo.guide_price }}</span
                >
              </p>
              <p class="dec_tit">车辆信息</p>
              <div class="dec_">{{ detailInfo.description }}</div>
            </van-col>
          </van-row>
          <p class="empty"></p>

          <div class="member_info">
            <div class="car_colors">
              <span class="tit">可选颜色</span>
              <span
                class="item_c"
                :class="{ active: selectedColor == index }"
                v-for="(item, index) in detailInfo.specifications"
                :key="index"
                @click="selectThisColor(item, index)"
                >{{ item }}</span
              >
            </div>
            <van-field
              v-model="member.lessees_name"
              label="姓名"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="租赁人姓名"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
            <van-field
              v-model="member.lessees_mobile"
              label="电话"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="租赁人手机号"
              type="number"
            />
            <van-field
              v-model="member.id_card"
              label="身份证"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="租赁人身份证号"
              onkeyup="value=value.replace(/[^\w]/ig,'')"
              onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
            />
            <van-field
              v-model="member.area_name"
              label="所在区域"
              format-trigger="onBlur"
              class="marTop12"
              placeholder="选择省/市/区"
              readonly
              @click="selectAddress()"
            />
            <van-field
              v-model="member.address"
              label="详细地址"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="街道门牌、楼层房间号等信息"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
            <div class="uploadBox">
              <p class="title">身份证正反面</p>
              <div class="img_box uploadBox1">
                <van-uploader
                  v-model="fileList1"
                  multiple
                  :max-count="1"
                  @oversize="onOversize"
                >
                  <!-- :after-read="afterRead1" -->
                  <div class="box_"></div>
                </van-uploader>
                <div class="opera" v-show="fileList1 && fileList1.length">
                  <div @click="change(1)">
                    <img src="../../assets/carRent/change@2x.png" />修改
                  </div>
                  <span></span>
                  <div class="opera_r" @click="delect(1)">
                    <img src="../../assets/carRent/delete@2x.png" />删除
                  </div>
                </div>
              </div>
              <div class="img_box img_box2 uploadBox2">
                <van-uploader
                  v-model="fileList2"
                  multiple
                  :max-count="1"
                  @oversize="onOversize"
                >
                  <div class="box_"></div>
                </van-uploader>
                <div class="opera" v-show="fileList2 && fileList2.length">
                  <div @click="change(2)">
                    <img src="../../assets/carRent/change@2x.png" />修改
                  </div>
                  <span></span>
                  <div class="opera_r" @click="delect(2)">
                    <img src="../../assets/carRent/delete@2x.png" />删除
                  </div>
                </div>
              </div>
            </div>

            <div class="uploadBox">
              <p class="title">驾驶证</p>
              <div class="img_box uploadBox3">
                <van-uploader
                  v-model="fileList3"
                  multiple
                  :max-count="1"
                  @oversize="onOversize"
                >
                  <div class="box_"></div>
                </van-uploader>
                <div class="opera" v-show="fileList3 && fileList3.length">
                  <div @click="change(3)">
                    <img src="../../assets/carRent/change@2x.png" />修改
                  </div>
                  <span></span>
                  <div class="opera_r" @click="delect(3)">
                    <img src="../../assets/carRent/delete@2x.png" />删除
                  </div>
                </div>
              </div>
            </div>
            <div class="tips">
              <p class="tip_">
                *您填写的姓名、电话、身份证、详细地址将用于汽车租赁资格审核
              </p>
            </div>
          </div>
          <p class="empty"></p>

          <div class="footer">
            <span class="price_"
              >租车订金<span class="label">￥</span
              ><span>{{
                Number(detailInfo.deposit_amount).toFixed(2)
              }}</span></span
            >
            <btn
              class="btn_"
              :btntext="'提交订单'"
              :btnwidth="'10.8rem'"
              :height="'4.8rem'"
              :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
              :borderradius="'0.6rem'"
              :btncolor="'#fff'"
              :fontsize="'1.6rem'"
              :fontweight="700"
              @btnClick="submit"
            />
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showArea" position="bottom" :overlay="true">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="areaList"
        @close="showArea = false"
        @finish="onFinish"
      />
    </van-popup>
    <van-popup class="tipPopup" v-model="tipsShow">
      <p class="title">温馨提示</p>
      <p class="con">
        您的申请已提交成功，申请正在审核中，稍后将有业务人员与您联系
      </p>
      <btn
        :btntext="'返回首页'"
        :btnwidth="'11.4rem'"
        :height="'3.6rem'"
        :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
        :borderradius="'0.6rem'"
        :btncolor="'#fff'"
        :fontsize="'1.4rem'"
        :btnmargin="'0 0 0 6.9rem'"
        @btnClick="goBack"
      />
    </van-popup>

    <div class="loading" v-if="loading">
      <img src="../../assets/common/loading.gif" />
    </div>
  </div>
</template>
<script>
import btn from "../purchaseSupplier/components/button.vue";
import productDefault from "@/assets/common/preload.png";
import { uploadMixin } from "../debtRelief/mixin";
import Upload from "../../providers/upload";
import dsbridge from "dsbridge";
export default {
  components: {
    btn,
  },
  mixins: [uploadMixin],
  data() {
    return {
      lefticon: require("@/assets/carRent/reback@2x.png"),
      detailInfo: {},
      swiper: [],
      label: 0,
      member: {
        order: {
          type: "car_rental_deposit",
        },
        quantity: 1,
        id_card_images: [],
      },
      fileList1: [],
      fileList2: [],
      fileList3: [],
      showArea: false,
      areaList: [],
      cascaderValue: "",
      selectedColor: 100,
      tipsShow: false,
      facility: "",
      paying: false,
      loading: false,
      client: "",
    };
  },
  created() {
    this.member.goods_id = this.$route.query.id;
    this.getInfo();
    this.handleInput();
    this.getArea();
  },
  mounted() {
    setTimeout(() => {
      document
        .querySelector(".car_detail")
        .addEventListener("scroll", this.handleScroll);
    }, 100);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    window.setPay = this.setPay;
    this.deductionUA();
  },
  methods: {
    // afterRead1(file) {
    //   console.log(file);
    //   console.log(file.file.size);
    // },
    goBack() {
      this.$router.go(-1);
    },
    handleInput() {
      window.addEventListener("resize", function () {
        window.setTimeout(function () {
          document.activeElement.scrollIntoView(false);
        }, 1);
      });
    },
    getInfo() {
      this.$api
        .post("/ongoods/member/car-goods/detail", {
          id: this.member.goods_id,
        })
        .then((res) => {
          this.swiper = res.images;
          this.detailInfo = res;
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    getArea() {
      this.$api.get("/platformsys/index/areas/list", {}).then((res) => {
        this.list = res.list;
        this.areaList = [];
        this.list.forEach((_) => {
          let item = {};
          item.text = _.name;
          item.value = _.code;
          if (_.children && _.children.length > 0) {
            item.children = [];
            _.children.forEach((__) => {
              let item1 = {};
              item1.text = __.name;
              item1.value = __.code;
              item.children.push(item1);
              if (__.children && __.children.length > 0) {
                item1.children = [];
                __.children.forEach((___) => {
                  let item2 = {};
                  item2.text = ___.name;
                  item2.value = ___.code;
                  item1.children.push(item2);
                });
              }
            });
          }
          this.areaList.push(item);
        });
      });
    },
    defaultPro() {
      var img = event.srcElement;
      img.src = productDefault;
      img.onerror = null; //防止闪图
    },
    onChange(index) {
      //轮播切换
      this.label = index;
    },
    selectAddress(index) {
      this.showArea = true;
      this.cascaderValue = "";
    },
    onFinish({ selectedOptions }) {
      this.showArea = false;
      this.member.area_name = "";
      this.member.area_name = selectedOptions
        .map((option) => option.text)
        .join("");
      if (selectedOptions[0])
        this.member.province_code = selectedOptions[0].value;
      if (selectedOptions[1]) this.member.city_code = selectedOptions[1].value;
      if (selectedOptions[2])
        this.member.district_code = selectedOptions[2].value;
    },
    selectThisColor(item, index) {
      this.selectedColor = index;
      this.member.specification_name = item;
    },
    async submit() {
      //   for (let item of this.invoiceInfo) {
      //     if (item.fileList.length != 0) {
      //       let _files = await Upload.startUpload(
      //         item.fileList.map((_) => _.file),
      //         ["others"]
      //       );
      //       item.invoice_image = _files[0];
      //     }
      //   }
      // 防止重复创建订单
      if (this.paying === true) {
        return;
      }
      if (!this.member.specification_name) {
        this.$toast("请选择车辆颜色");
        return;
      }
      if (!this.member.lessees_name) {
        this.$toast("请填写租赁人姓名");
        return;
      }
      if (!this.member.lessees_mobile) {
        this.$toast("请填写租赁人手机号");
        return;
      }
      if (!this.member.id_card) {
        this.$toast("请填写租赁人身份证号");
        return;
      }
      if (!this.member.area_name) {
        this.$toast("请填写租赁人所在省市区名称");
        return;
      }
      if (!this.member.address) {
        this.$toast("请填写租赁人详细地址");
        return;
      }
      if (this.fileList1.length == 0) {
        this.$toast("请上传身份证正反面照片");
        return;
      }
      if (this.fileList2.length == 0) {
        this.$toast("请上传身份证正反面照片");
        return;
      }
      if (this.fileList3.length == 0) {
        this.$toast("请上传驾驶证照片");
        return;
      }

      this.loading = true;
      let _files1 = await Upload.startUpload(
        this.fileList1.map((_) => _.file),
        ["others"]
      );
      this.member.id_card_images[0] = _files1[0];

      let _files2 = await Upload.startUpload(
        this.fileList2.map((_) => _.file),
        ["others"]
      );
      this.member.id_card_images[1] = _files2[0];

      let _files3 = await Upload.startUpload(
        this.fileList3.map((_) => _.file),
        ["others"]
      );
      this.member.drivers_license_image = _files3[0];

      this.paying = true;

      // 确认订单
      await this.$api
        .post("/order/member/order/confirm", this.member)
        .then((data) => {
          let confirm = data.order.confirm;
          var member_ = this.member;
          member_.order = {
            type: "car_rental_deposit",
            client: this.client,
            confirm: confirm,
          };
          // 创建订单
          this.$api
            .post("/order/member/order/create", member_)
            .then((data) => {
              let param = {
                actual_amount: data.actual_amount,
                order_amount: data.order_amount,
                ordersn: data.ordersn,
                order_type: "car_rental_deposit",
              };
              if (this.facility == "ios") {
                let that = this;
                dsbridge.call("goPay", JSON.stringify(param), function (v) {
                  that.setPay(v);
                });
              } else if (this.facility == "android") {
                this.params(
                  JSON.stringify(param),
                  JSON.stringify(param),
                  "goPay"
                );
              }
              this.paying = false;
              this.loading = false;
            })
            .catch((err) => {
              this.paying = false;
              this.loading = false;
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
              } else {
                this.$toast(message);
              }
              return;
            });
        })
        .catch((err) => {
          this.paying = false;
          this.loading = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.tipsShow = true;
      } else {
        this.$router.replace("/carRent/orderList");
      }
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.facility = "ios";
        this.client = 11;
      } else if (/android/.test(ua)) {
        this.facility = "android";
        this.client = 10;
      }
    },
    change(i) {
      switch (i) {
        case 1:
          this.fileList1 = [];
          setTimeout(() => {
            document.querySelector(".uploadBox1 input").click();
          }, 10);
          break;
        case 2:
          this.fileList2 = [];
          setTimeout(() => {
            document.querySelector(".uploadBox2 input").click();
          }, 10);
          break;
        case 3:
          this.fileList3 = [];
          setTimeout(() => {
            document.querySelector(".uploadBox3 input").click();
          }, 10);
          break;
        default:
      }
    },
    delect(i) {
      switch (i) {
        case 1:
          this.fileList1 = [];
          break;
        case 2:
          this.fileList2 = [];
          break;
        case 3:
          this.fileList3 = [];
          break;
        default:
      }
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.car_rent_detail {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .car_detail {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .detail_box {
      height: 100%;
      position: relative;

      .back {
        position: absolute;
        top: 5.4rem;
        left: 1.2rem;
        width: 2.4rem;
        z-index: 3;
      }

      .banner {
        position: absolute;
        top: 0;
        left: 0;

        .car_rent_swipe {
          .item {
            width: 100%;
            height: 27.7rem;
          }
          .custom-indicator {
            /*position: relative;*/
            height: 100%;
            color: rgba(0, 0, 0, 0);
            .indexes {
              width: 4.2rem;
              height: 2.4rem;
              line-height: 2.4rem;
              border-radius: 0.4rem;
              color: #fff;
              font-size: 1.4rem;
              text-align: center;
              background: rgba(0, 0, 0, 0.38);
              display: inline-block;
              position: absolute;
              right: 1.2rem;
              top: 22.5rem;
              z-index: 5;
            }
          }
        }
      }

      .car_dec {
        position: absolute;
        top: 26.1rem;
        left: 0;
        height: auto;
        background: #fff;
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        padding: 2rem 0 0;

        .car_detail_dec {
          padding: 0 1.6rem 1.6rem;
          .name {
            color: #000;
            font-size: 1.8rem;
            font-weight: 700;
            line-height: 2.5rem;
            margin-bottom: 1rem;
          }

          .price {
            color: #ff4747;
            font-size: 1.6rem;
            font-weight: 700;

            .unit {
              font-size: 2.2rem;
            }

            .dec {
              color: #999;
              font-size: 1.4rem;
            }

            .full_price {
              color: #999;
              font-size: 1.4rem;
              margin-left: 1.8rem;
            }
          }

          .dec_tit {
            color: #000;
            font-size: 1.4rem;
            font-weight: 700;
            margin: 1.8rem 0 0.8rem;
          }

          .dec_ {
            color: #333;
            font-size: 1.4rem;
            padding: 1.6rem;
            background: #f7f9fb;
            border-radius: 0.4rem;
          }
        }

        .empty {
          height: 1.2rem;
          background: #f5f6f7;
        }

        .member_info {
          padding: 1.6rem 0;
          background: #fff;

          .car_colors {
            margin-bottom: 1.5rem;
            padding: 0 1.6rem 0 11rem;
            position: relative;

            .tit {
              position: absolute;
              top: 0.5rem;
              left: 1.6rem;
              color: #333;
              font-size: 1.4rem;
            }

            .item_c {
              color: #999;
              font-size: 1.2rem;
              //   width: 5.4rem;
              height: 3rem;
              line-height: 3rem;
              margin: 0 0.8rem 0.8rem 0;
              background: #f7f7f7;
              border-radius: 0.4rem;
              display: inline-block;
              text-align: center;
              padding: 0 1.5rem;
            }

            .active {
              color: #236dfe;
              background: #ebf2fe;
            }
          }

          .uploadBox {
            margin-top: 1.5rem;
            height: 13.1rem;
            padding: 0 1.6rem;
            box-sizing: border-box;

            .title {
              color: #333;
              font-size: 1.4rem;
              line-height: 2rem;
              margin-bottom: 1.2rem;
            }

            .img_box {
              width: 16rem;
              height: 9.9rem;
              float: left;
              position: relative;

              .opera {
                color: #fff;
                width: 16rem;
                height: 3rem;
                background: rgba(0, 0, 0, 0.41);
                border-bottom-left-radius: 0.6rem;
                border-bottom-right-radius: 0.6rem;
                position: absolute;
                bottom: 0;
                left: 0;
                z-index: 1;

                div {
                  width: 7.9rem;
                  line-height: 3rem;
                  display: inline-block;
                  text-align: center;

                  img {
                    width: 1.4rem;
                    vertical-align: middle;
                    margin-right: 0.6rem;
                  }
                }

                .opera_r {
                  float: right;
                }

                span {
                  width: 0.1rem;
                  height: 1.2rem;
                  background: #fff;
                  display: inline-block;
                }
              }
            }

            .img_box2 {
              float: right;
            }

            /deep/ .van-uploader__preview {
              width: 16rem;
              height: 9.9rem;
              padding: 0;
              margin: 0;
            }

            /deep/ .van-image__img,
            /deep/ .van-image__error,
            /deep/ .van-image__loading,
            /deep/ .van-uploader__preview-image {
              width: 16rem;
              height: 9.9rem;
            }

            /deep/ .van-uploader__preview-delete {
              display: none;
            }

            .box_ {
              width: 16rem;
              height: 9.9rem;
              background: url(../../assets/carRent/upload@2x.png) no-repeat
                center center;
              background-size: 100%;
              box-sizing: border-box;
            }
          }

          .tips {
            color: #ff4747;
            font-size: 1.2rem;
            padding: 0 1.6rem;
            margin-top: 1.6rem;

            .tip_ {
              height: 5rem;
              line-height: 1.7rem;
              padding: 0.8rem 1.4rem;
              background: #fff2f2;
              box-sizing: border-box;
            }
          }
        }

        .footer {
          height: 9.8rem;
          padding: 0 1.6rem 2.2rem;
          box-sizing: border-box;

          .price_ {
            height: 7.6rem;
            line-height: 7.6rem;
            color: #333333;
            font-size: 1.4rem;

            span {
              color: #ff4747;
              font-size: 2rem;
            }

            .label {
              font-size: 1.4rem;
            }
          }

          .btn_ {
            float: right;
            margin-top: 1.4rem;
          }
        }
      }
    }
  }

  .tipPopup {
    width: 29.6rem;
    border-radius: 0.8rem;
    padding: 3rem 2.2rem 2.2rem;
    box-sizing: border-box;
    color: #333;

    .title {
      font-size: 1.6rem;
      font-weight: 700;
      text-align: center;
      margin-bottom: 2rem;
    }

    .con {
      font-size: 1.4rem;
      line-height: 2.5rem;
      margin-bottom: 4.2rem;
    }
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
}
</style>




